import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { HostedAppPage } from './HostedAppPage';
import { HOSTED_APPLICATIONS_PLUGIN_ID } from './hostedApps';

export const hostedAppRouteRef = createRouteRef();

const hostedAppPageExtension = PageBlueprint.make({
  name: 'hosted-app',
  params: {
    path: '/apps/:appId',
    routeRef: hostedAppRouteRef,
    loader: async () => <HostedAppPage />,
  },
});

export const hostedApplicationsPlugin = createFrontendPlugin({
  pluginId: HOSTED_APPLICATIONS_PLUGIN_ID,
  routes: { hostedApp: hostedAppRouteRef },
  extensions: [hostedAppPageExtension],
});
